/* Hillsdale HTML navigation only; Shopify cart/API fetches stay unchanged. */
(() => {
  const url=new URL(location.href),target=new URL('/',url.origin);
  if(url.searchParams.has('preview_theme_id'))target.searchParams.set('preview_theme_id',url.searchParams.get('preview_theme_id'));
  if(/^\/products\/[a-z0-9-]+\/?$/.test(url.pathname)) {
    target.searchParams.set('product',url.pathname.replace(/\/$/,''));
    if(url.searchParams.has('variant'))target.searchParams.set('variant',url.searchParams.get('variant'));
  } else if(url.pathname==='/cart') target.hash='cart';
  else if(url.pathname==='/station') {
    target.pathname='/pages/station';
    if(url.searchParams.has('station'))target.searchParams.set('station',url.searchParams.get('station'));
    target.hash=url.hash;
  } else if(url.pathname==='/pages/hillsdale-mug-walkthrough') {
    target.search=url.search;target.hash=url.hash;
  } else return;
  location.replace(target.href);
})();
